import { React, useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col } from 'react-bootstrap';
import { createSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Search = ({ setSearchState }) => {
  let navigate = useNavigate();
  const location = useLocation();
  const [searchtextValue, setSearchtextValue] = useState('');
  const previousRoute = useSelector(
    (state) => state.previousRoute.previousRoute
  );
  const selectSearchInputRef = useRef();

  // Initialize search input with URL search keyword
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const searchKeyword = searchParams.get('searchKeyword');
    if (searchKeyword) {
      setSearchtextValue(searchKeyword);
      setSearchState(searchKeyword);
    }
  }, [location.search, setSearchtextValue, setSearchState]);

  const handlesearchInput = (e) => {
    setSearchtextValue(e.target.value);
  };
  const handleResetSearch = () => {
    setSearchtextValue('');
    setSearchState('');
    if (selectSearchInputRef.current?.resetSelectedValues) {
      selectSearchInputRef.current.resetSelectedValues();
    }
    // Navigate to the last non-search page
    if (previousRoute === '/advanced-search') {
      navigate('/');
    } else {
      navigate(previousRoute);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchState(searchtextValue);
    navigate({
      pathname: '/search-result',
      search: `?${createSearchParams({ searchKeyword: searchtextValue })}`,
    });
  };

  const handleAdvancedSearch = () => {
    navigate('/advanced-search');
  };


  return (
    <>
      <Row className='g-0'>
        <Col lg={12}>
          <form onSubmit={handleSearch} className='ctx-search-form'>
            <div style={{ position: 'relative' }}>
              <input
                className='ctx-search'
                placeholder='Search'
                name='search'
                type='text'
                value={searchtextValue}
                onChange={handlesearchInput}
              />
              <button
                type='button'
                onClick={handleResetSearch}
                className='cstm-search-clear-btn'
              >
                <FontAwesomeIcon icon={['fal', 'times']} />
              </button>
            </div>
            <button type='submit' className='ctx-search-btn'>
              <FontAwesomeIcon icon={['fal', 'search']} />
            </button>

            <button
              type='button'
              className='ctx-advanced-search-btn'
              onClick={handleAdvancedSearch}
            >
              Advanced Search
              <FontAwesomeIcon
                icon={['fal', 'arrow-right']}
                style={{ marginLeft: '8px' }}
              />
            </button>

          </form>
        </Col>
      </Row>
    </>
  );
};
export default Search;
